import {
    CompanyRoleType as CompanyRoleTypeGenerated,
    CompanySearchResult as CompanySearchResultGenerated,
    CommerceDetailDTO as CommerceDetailResult,
    CommerceSearchResultDTO as CommerceSearchResult,
    CommerceSearchResultDTOPagedListPagedApiResponse as CompanySearchResultPagedListPagedApiResponse
} from '@/types/__generated__/companies'

export type CompanyRoleType = CompanyRoleTypeGenerated
export const COMPANY_ROLE_TYPE = {
    DevicesReporter: 1 as CompanyRoleType,
    Collector: 2 as CompanyRoleType,
    ServiceProvider: 3 as CompanyRoleType,
    Transporter: 4 as CompanyRoleType,
    BatteriesReporter: 5 as CompanyRoleType,
    ComplianceCompany: 6 as CompanyRoleType,
    ReporterEpacExport: 7 as CompanyRoleType,
    ReporterBatteriesExport: 8 as CompanyRoleType,
    ReporterDevicesExport: 9 as CompanyRoleType,
    ExportReuse: 10 as CompanyRoleType,
    ReporterEpac: 11 as CompanyRoleType,
}

export interface CommerceDetailDTO extends CommerceDetailResult {}

export interface CompanySearchResult extends CompanySearchResultGenerated {}

export interface CommerceSearchResultDTO extends CommerceSearchResult {}

export interface ReadCompanySearchResultApiResponse extends CompanySearchResultPagedListPagedApiResponse {}
